import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProjectCreateComponent } from './project-create.component';
import { AuthGuardService } from '../../authentication/auth-guard.service';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { ResourceAssignedComponent } from './tabs/project-information/resource-assigned/resource-assigned.component';
import { ProjectsModule } from '../projects.module';
import { WorkLogComponent } from './tabs/work-log/work-log.component';
// import { AddOnsModule } from './tabs/add-ons/add-ons.module';
// import { CommonMonthPickerComponent } from 'app/shared/common/common-month-picker/common-month-picker.component';

const routes = [
  { path: '', redirectTo: 'project-create', pathMatch: 'full', canActivate: [AuthGuardService] },
  { path: 'project-create', component: ProjectCreateComponent, canActivate: [AuthGuardService] },
  { path: 'project-detail', component: ProjectCreateComponent, canActivate: [AuthGuardService] },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatFormFieldModule,
    MatOptionModule,
    MatSelectModule,
    MatDatepickerModule,
    NgbModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
    MatTooltipModule,
    VirtualScrollerModule,
    // AddOnsModule
    // ProjectsModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
  declarations: [ResourceAssignedComponent,
    WorkLogComponent
    ],
    exports:[
      WorkLogComponent
    ]
})

export class ProjectCreateModule { }
